import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PhoneFormData } from '../interfaces/phone-form-data.interface';

const phoneFormState: PhoneFormData & Record<string, any> = {
  phone: "",
  agreement: true
}

export const phoneFormSlice = createSlice({
  name: "phone-form",
  initialState: phoneFormState,
  reducers: {
    update: (state, action: PayloadAction<Partial<PhoneFormData>>) => {
      return { ...state, ...action.payload };
    }
  }
});

export const { update } = phoneFormSlice.actions;
export default phoneFormSlice.reducer;